'use client';

import { useWallet, WalletContextState } from '@solana/wallet-adapter-react';

import { useMemo } from 'react';

/**
 * WARNING::
 * - This context does not update in sync with our wallet emulation feature
 * - It should only be used when you are doing "actual wallet management" for a real wallet in the solana wallet context. If you just want to fetch the "current wallet" use the value in the drift store.
 *
 * 🚨 TODO
 * This hook needs to act as a black box, managing the wallet context state for both @solana/wallet-adapter-react and @reown/appkit/react. If done correctly then the output of this hook should exactly match the functionality of the @solana/wallet-adapter-react `useWallet` hook.
 * **/

/**
 * custom useWalletContext to abstract away @solana/wallet-adapter-react
 * @returns
 */
const useWalletContext = (): WalletContextState => {
	const walletContext_ = useWallet();

	const walletContext = useMemo(() => {
		return {
			publicKey: walletContext_.publicKey,
			wallets: walletContext_.wallets,
			wallet: walletContext_.wallet,
			adapter: walletContext_.wallet?.adapter,
			select: walletContext_.select,
			disconnect: walletContext_.disconnect,
			autoConnect: walletContext_.autoConnect,
			connecting: walletContext_.connecting,
			connected: walletContext_.connected,
			disconnecting: walletContext_.disconnecting,
			sendTransaction: walletContext_.sendTransaction,
			signTransaction: walletContext_.signTransaction,
			signAllTransactions: walletContext_.signAllTransactions,
			signMessage: walletContext_.signMessage,
			signIn: walletContext_.signIn,
			connect: walletContext_.connect,
		};
	}, [walletContext_, walletContext_?.publicKey?.toBase58() ?? '']);

	return walletContext;
};

export default useWalletContext;
